const state = {
    inspectTimeoutDataFields: [
        {
            key: "device_name",
            label: "機台",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "batch_qty",
            label: "批數小計",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "inspect_qty",
            label: "檢驗筆數小計",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "timeout_qty",
            label: "超時筆數小計",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        }
    ],
    inspectTimeoutDataItem: [
        // {
        //     device_name: "F12",
        //     batch_qty: 3,
        //     inspect_qty: 20,
        //     timeout_qty: 1
        // },
        // {
        //     device_name: "F13",
        //     batch_qty: 5,
        //     inspect_qty: 18,
        //     timeout_qty: 2
        // }
    ],
    device_total_qty: 0,
    batch_total_qty: 0,
    inspect_total_qty: 0,
    timeout_total_qty: 0,
    inspectTimeoutDetailData: {
        // F12: [
        //     {
        //         device_name: "F12",
        //         batch_qty: 3,
        //         inspect_qty: 20,
        //         timeout_qty: 2,
        //         batch: "44961X",
        //         last_time: "2022/10/10 21:13:12",
        //         this_time: "2022/10/10 23:23:22",
        //         interval_time: "02:10:10",
        //         main_insp: "F12_44961X_2022/10/10 21:13:12"
        //     },
        //     {
        //         // device_name: "",
        //         // batch_qty: 5,
        //         // inspect_qty: 18,
        //         // timeout_qty: 2,
        //         batch: "44962X",
        //         last_time: "2022/10/10 21:13:12",
        //         this_time: "2022/10/10 23:45:21",
        //         interval_time: "02:32:09",
        //         main_insp: "F12_44961X_2022/10/10 21:13:12"
        //     }
        // ],
        // F13: [
        //     {
        //         device_name: "F13",
        //         batch_qty: 3,
        //         inspect_qty: 20,
        //         timeout_qty: 4,
        //         batch: "44961X",
        //         last_time: "2022/10/10 21:13:12",
        //         this_time: "2022/10/10 23:23:22",
        //         interval_time: "02:10:10",
        //     },
        //     {
        //         // device_name: "",
        //         // batch_qty: 5,
        //         // inspect_qty: 18,
        //         // timeout_qty: 2,
        //         batch: "44962X",
        //         last_time: "2022/10/10 21:13:12",
        //         this_time: "2022/10/10 23:45:21",
        //         interval_time: "02:32:09"
        //     },
        //     {
        //         // device_name: "",
        //         // batch_qty: 5,
        //         // inspect_qty: 18,
        //         // timeout_qty: 2,
        //         batch: "44962X",
        //         last_time: "2022/10/10 21:13:12",
        //         this_time: "2022/10/10 23:45:21",
        //         interval_time: "02:32:09"
        //     },
        //     {
        //         // device_name: "",
        //         // batch_qty: 5,
        //         // inspect_qty: 18,
        //         // timeout_qty: 2,
        //         batch: "44962X",
        //         last_time: "2022/10/10 21:13:12",
        //         this_time: "2022/10/10 23:45:21",
        //         interval_time: "02:32:09"
        //     }
        // ]
    },
    inspectTimeoutShowDetail: false
};
const getters = {
    get_inspectTimeoutDataFields: state => {
        return state.inspectTimeoutDataFields;
    },
    get_inspectTimeoutDataItem: state => {
        return state.inspectTimeoutDataItem;
    },
    get_device_total_qty: state => {
        return state.device_total_qty;
    },
    get_batch_total_qty: state => {
        return state.batch_total_qty;
    },
    get_inspect_total_qty: state => {
        return state.inspect_total_qty;
    },
    get_timeout_total_qty: state => {
        return state.timeout_total_qty;
    },
    get_inspectTimeoutDetailData: state => {
        return state.inspectTimeoutDetailData;
    },
    get_inspectTimeoutShowDetail: state => {
        return state.inspectTimeoutShowDetail;
    }
};
const actions = {
    set_inspectTimeoutDataFields(context, array) {
        context.commit("SET_INSPECTTIMEOUTDATAFIELDS", array);
    },
    set_inspectTimeoutDataItem(context, array) {
        context.commit("SET_INSPECTTIMEOUTDATAITEM", array);
    },
    clear_inspectTimeoutDataItem(context) {
        context.commit("CLEAR_INSPECTTIMEOUTDATAITEM");
    },
    set_device_total_qty(context, number) {
        context.commit("SET_DEVICE_TOTAL_QTY", number);
    },
    set_batch_total_qty(context, number) {
        context.commit("SET_BATCH_TOTAL_QTY", number);
    },
    set_inspect_total_qty(context, number) {
        context.commit("SET_INSPECT_TOTAL_QTY", number);
    },
    set_timeout_total_qty(context, number) {
        context.commit("SET_TIMEOUT_TOTAL_QTY", number);
    },
    set_inspectTimeoutDetailData(context, object) {
        context.commit("SET_INSPECTTIMEOUTDETAILDATA", object);
    },
    clear_inspectTimeoutDetailData(context) {
        context.commit("CLEAR_INSPECTTIMEOUTDETAILDATA");
    },
    set_inspectTimeoutShowDetail(context, boolean) {
        context.commit("SET_INSPECTTIMEOUTSHOWDETAIL", boolean);
    }
};
const mutations = {
    SET_INSPECTTIMEOUTDATAFIELDS(state, array) {
        state.inspectTimeoutDataFields = array;
    },
    SET_INSPECTTIMEOUTDATAITEM(state, array) {
        state.inspectTimeoutDataItem = array;
    },
    CLEAR_INSPECTTIMEOUTDATAITEM(state) {
        state.inspectTimeoutDataItem = [];
    },
    SET_DEVICE_TOTAL_QTY(state, number) {
        console.log(number);
        state.device_total_qty = number;
    },
    SET_BATCH_TOTAL_QTY(state, number) {
        state.batch_total_qty = number;
    },
    SET_INSPECT_TOTAL_QTY(state, number) {
        state.inspect_total_qty = number;
    },
    SET_TIMEOUT_TOTAL_QTY(state, number) {
        state.timeout_total_qty = number;
    },
    SET_INSPECTTIMEOUTDETAILDATA(state, object) {
        state.inspectTimeoutDetailData = object;
    },
    CLEAR_INSPECTTIMEOUTDETAILDATA(state) {
        state.inspectTimeoutDetailData = {};
    },
    SET_INSPECTTIMEOUTSHOWDETAIL(state, boolean) {
        state.inspectTimeoutShowDetail = boolean;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/inspectTimeoutData.js